import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { defaultPagingChoices, emptyCellContent } from "@/js/lists.ts";
import { request } from "@/js/http/http_request";
import { getLoggedUserData, isSalesman } from "@/js/http/auth";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import ContactPopin from "@/components/contact/ContactPopin.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "ContactList",
  data: function data() {
    return {
      loggedUserData: {},
      datatable_loading: true,
      datatable_selected: [],
      datatable_headers: [{
        text: "Status",
        align: "center",
        value: "treated"
      }, {
        text: "Read",
        align: "center",
        value: "read"
      }, {
        text: "Name",
        align: "start",
        value: "name"
      }, {
        text: "Email",
        value: "email"
      }, {
        text: "Subject",
        value: "subject"
      }, {
        text: "Message",
        value: "message_overview"
      }, {
        text: "Date contact",
        align: "start",
        value: "date_contact"
      }, {
        text: "Salesperson",
        value: "salesman"
      }, {
        text: "Actions",
        value: "actions"
      }],
      datatable_items: [],
      baseModel: {
        contacts: [],
        numberOfContacts: 0,
        numberOfPages: 0
      },
      selectedRows: [],
      pagingLimitsChoices: defaultPagingChoices,
      searchCriterias: {
        name: "",
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        },
        label: "",
        treated: null,
        read: null,
        salesmanId: null
      },
      filterTreated: [{
        id: "TREATED",
        label: "Treated",
        value: true
      }, {
        id: "NOT_TREATED",
        label: "Not treated",
        value: false
      }],
      filterRead: [{
        id: "READ",
        label: "Read",
        value: true
      }, {
        id: "NOT_READ",
        label: "Not read",
        value: false
      }],
      listSalesman: [],
      emptyCellContent: emptyCellContent
    };
  },
  components: {
    paging: pagingComponent,
    index: indexComponent,
    "contact-popin": ContactPopin,
    confirm: confirmationComponent
  },
  computed: {
    isMarkableAsRead: function isMarkableAsRead() {
      var unReadedList = this.selectedRows.filter(function (x) {
        return !x.read;
      });
      if (!unReadedList.length) return true;
    },
    isMarkableAsTreated: function isMarkableAsTreated() {
      var unTreatedList = this.selectedRows.filter(function (x) {
        return !x.treated;
      });
      if (!unTreatedList.length) return true;
    },
    hasResult: function hasResult() {
      return !this.datatable_loading && this.baseModel.numberOfContacts > 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.loggedUserData = getLoggedUserData();
            _context.next = 3;
            return request("/v1/users", "post", {
              user_group: ["ADMIN"],
              roles: [process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER],
              active: true,
              isSalesman: true
            }, true, "api");
          case 3:
            response = _context.sent;
            _this2.listSalesman = response.data.users;
            _this2.listSalesman.sort(function (a, b) {
              return b.fullname < a.fullname ? 1 : -1;
            });
            _this2.listSalesman.unshift({
              id_user: 0,
              fullname: "No salesperson attached"
            });
            if (isSalesman(_this2.loggedUserData)) {
              _this2.searchCriterias.salesmanId = +_this2.loggedUserData.idUser;
            }
            _this2.search();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
      }
    },
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      var _this = this;
      document.body.style.cursor = "wait";
      _this.datatable_loading = true;
      if (isResetPaging) _this.resetPaging();
      request("/v1/contacts", "post", _this.searchCriterias, true, "api").then(function (response) {
        _this.baseModel.contacts.splice(_this.searchCriterias.paging.limits);
        _this.baseModel = {
          contacts: response.data.contacts,
          numberOfContacts: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / _this.searchCriterias.paging.limits)
        };
        _this.searchCriterias.paging.currentPage = _this.searchCriterias.paging.askedPage + 1;
        if (!_this.searchCriterias.paging.currentPage) {
          _this.searchCriterias.paging.currentPage = 0;
        }
        _this.datatable_items = response.data.contacts;
      });
      document.body.style.cursor = "default";
      _this.datatable_loading = false;
      _this.$EventBus.$emit("loading", false);
    },
    rowClicked: function rowClicked(item) {
      this.showDetails(item);
    },
    showDetails: function showDetails(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.$refs.contact.open(item);
              if (item.read) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return request("/v1/contacts/read", "post", [item.id_contact], true, "api");
            case 4:
              _this3.search();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    markMultipleAsRead: function markMultipleAsRead() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var selectedIds;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              selectedIds = _this4.selectedRows.filter(function (x) {
                return !x.read;
              }).map(function (x) {
                return x.id_contact;
              });
              _this4.$EventBus.$emit("loading", true);
              _context3.next = 4;
              return request("/v1/contacts/read", "post", selectedIds, true, "api");
            case 4:
              _this4.$EventBus.$emit("loading", false);
              _this4.selectedRows = [];
              _this4.search();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    confirmTreated: function confirmTreated(idContact) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.$refs.confirm.open("Cancel", "Are you sure you want to mark this contact request as 'Treated'?", {
                color: "red"
              });
            case 2:
              confirmed = _context4.sent;
              if (confirmed) {
                _this5.requestTreated([idContact]);
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    requestTreated: function requestTreated(idsContact) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.$EventBus.$emit("loading");
              _context5.next = 3;
              return request("/v1/contacts/treat", "post", idsContact, true, "api");
            case 3:
              _this6.$EventBus.$emit("loading", false);
              _this6.selectedRows = [];
              _this6.search();
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    confirmNotTreated: function confirmNotTreated(idContact) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.$refs.confirm.open("Cancel", "Are you sure you want to mark this contact request as 'Not treated'?", {
                color: "red"
              });
            case 2:
              confirmed = _context6.sent;
              if (confirmed) {
                _this7.requestNotTreated([idContact]);
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    requestNotTreated: function requestNotTreated(idsContact) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var path;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.$EventBus.$emit("loading");
              path = "/v1/contacts/untreat";
              _context7.next = 4;
              return request(path, "post", idsContact, true, "api");
            case 4:
              _this8.$EventBus.$emit("loading", false);
              _this8.selectedRows = [];
              _this8.search();
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    markMultipleAsTreated: function markMultipleAsTreated() {
      var selectedIds = this.selectedRows.filter(function (x) {
        return !x.treated;
      }).map(function (x) {
        return x.id_contact;
      });
      this.requestTreated(selectedIds);
    },
    readBackground: function readBackground(item) {
      return !item.read ? "datatable-line-read" : "";
    }
  }
};